import React, { Component } from 'react';
import DocumentTitle from 'react-document-title';
import './style.less';

class PrivacyPage extends Component {
    constructor(props){
        super(props);
        this.state = {};
    }
    render(){
        return(
            <DocumentTitle title={'用户隐私协议'}>
                <div className="container privacyrules">
                    <h1>《用户隐私协议》</h1>
                    <h3>一、用户隐私</h3>
                    <p className="pageone">
                      欢迎您使用爱课平台，爱课平台（以下简称“爱课”）是由杭州潘哒网络科技有限公司所管理，爱课对每一位用户的隐私权采取高度尊重且保护的态度。杭州潘哒网络科技有限公司（以下简称“管理公司”）在此做严谨的声明，为了协助您了解爱课如何取得、使用并进一步保护您的个人信息，爱课将明确地阐述我们的隐私权保护政策、收集的您的个人信息类型及其对应的用途。以下条款的约定针对使用本平台服务的用户与消费者，经用户浏览并同意后生效。
                    </p>
                    <p>
                      本政策构成《爱课服务使用协议》的完整组成部分，其适用范围，为爱课所有使用者（但不包括爱课聘用管理的员工），包括但不限于使用者注册爱课用户时的相关个人信息，及与爱课共同合作、协作时使用到的个人资料。
                    </p>
                    <h3>二、个人信息之取得与使用</h3>
                    <p className="pagetwo">
                      爱课除了注册和运营活动外不会主动要求使用者提供任何个人信息。爱课将记录用户的使用时间和路径，该等记录只为了向您提供更好的产品功能及体验。此信息不会针对特定个人进行个别分析。爱课可能会获取您个人资料的情形与目的：
                    </p>
                    <p>1. 当您注册爱课账户时，您同意向爱课提供一些个人信息（包括但不限于姓名、性别、电话号码、年龄、微信号、支付宝等支付渠道账号、地址、电子邮箱、身份信息、证件号码、银行卡号、头像、兴趣爱好等）。爱课收集这些信息是为了帮助您完成爱课账户注册，保护您帐号的安全，为识别用户的身份并为您推荐您更感兴趣的服务，您应对账户信息及密码承担保密责任，因您未能尽到信息安全和保密责任而致使您的账户发生任何问题的，将由您承担全部责任。同时，因网络环境存在众多不可预知因素，或因您自身终端网络原因（包括但不限于断网、黑客攻击、病毒等）造成您的账户或个人信息等被第三方窃取的，爱课及其管理公司、管理公司关联方将不承担任何赔偿责任。</p>
                    <p>2. 当您访问爱课时，或使用爱课提供的服务时，爱课可能会记录用户操作的相关信息（包括但不限于用户的计算机IP地址、设备标识符、硬件型号、操作系统版本、用户的位置以及与爱课服务相关的日志信息），以便优化爱课为您提供更好的服务。您对此予以理解并同意。</p>
                    <p>3. 除上述信息外，爱课还可能为了提供服务、改进服务质量及相关研究的合理需要而收集用户的其他信息，用户与爱课的客户服务团队联系时用户所提供的相关信息，用户参与问卷调查时向爱课发送的问卷答复信息，以及用户与爱课及其关联方互动时爱课收集的相关信息。您对此予以理解并同意。</p>
                    <p>
                    4、根据相关法律法规及国家标准，在以下情形中，爱课可能会依法收集并使用您的个人信息并且无需征得您的同意:
                        <span>（1）与国家安全、国防安全直接相关的；</span>
                        <span>（2）与公共安全、公共卫生、重大公共利益直接相关的；</span>
                        <span>（3）与犯罪侦查、起诉、审判和判决执行等直接相关的；</span>
                        <span>（4）出于维护用户或他人的生命、财产等重大合法权益但又很难得到用户本人同意的；</span>
                        <span>（5）所收集的个人信息是用户自行向社会公众公开的；</span>
                        <span>（6）从合法公开披露的信息中收集个人信息，例如：合法的新闻报道、政府信息公开等渠道；</span>
                        <span>（7）根据用户的要求签订和履行合同所必需的；</span>
                        <span>（8）用于维护所提供的服务的安全稳定运行所必需的，例如：发现、处置产品或服务的故障；</span>
                        <span>（9）为合法的新闻报道所必需的；</span>
                        <span>（10）学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；</span>
                        <span>（9）法律法规规定的其他情形。</span>
                    </p>
                   <p>5.爱课不会主动共享或转让您的个人信息至第三方，除非另行取得您的事先同意，否则爱课不会将这些信息授权给与履行本协议无关的第三方用于商业目的。</p>
                   <p>6. 尽管有前述规定，在以下情形中，爱课向第三方提供您的个人信息无需事先征得您的授权同意：
                        <span>（1）与国家安全、国防安全直接相关的；</span>
                        <span>（2）与公共安全、公共卫生、重大公共利益直接相关的；</span>
                        <span>（3）与犯罪侦查、起诉、审判和判决执行等直接相关的；</span>
                        <span>（4）出于维护用户或他人的生命、财产等重大合法权益但又很难得到用户本人同意的；</span>
                        <span>（5）所收集的个人信息是用户自行向社会公众公开的；</span>
                        <span>（6）从合法公开披露的信息中收集个人信息，例如：合法的新闻报道、政府信息公开等渠道；</span>
                   </p>
                   <p>7.根据法律规定，向第三方提供经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。</p>
                   <p>8.按照法律法规规定，我们将境内收集的用户个人信息存储于中国境内。一般而言，我们仅为实现目的所必需的时间保留您的个人信息，例如：若您需要使用爱课服务，我们需要一直保存您的手机号码，以保证您正常使用该服务，当您注销帐户后，我们将删除相应的信息。当我们的产品或服务发生停止运营的情形时，我们将以推送通知、公告等形式通知您，并在合理的期限内删除您的个人信息或进行匿名化处理。</p>
                    <h3>三、其他</h3>
                    <p>
                    为保障用户的信息安全，爱课一直并将继续努力采取各种合理的物理、电子和管理方面的安全措施来保护用户信息，使用户的信息不会被泄漏、毁损或者丢失，包括但不限于信息加密存储、数据中心的访问控制。爱课对可能接触到用户的信息的员工或外包人员也采取了严格管理，包括但不限于根据岗位的不同设置不同的权限，与员工签署保密协议等措施。但根据相关法规或政府为履行职务而要求爱课提供上述信息的除外。若您对爱课的隐私权有任何疑问，或者您认为权力遭到侵犯时，欢迎您提供宝贵意见给我们。爱课将尽一切努力尽快改善您所提出的各项建议，以便提供您更完善的服务。
                    </p>
                    <h3>四、与我们联系</h3>
                    <p>当您有其他的投诉、建议、未成年人个人信息相关问题时，请通过官网<b>https://www.aircourses.com</b>与我们联系或拨打4008-874-877进行反馈。</p>
                    <p>我们将尽快审核所涉问题，并在验证您的用户身份后的三十天内予以回复。</p>
                </div>
            </DocumentTitle>
        )
    }
}

export default PrivacyPage;




// WEBPACK FOOTER //
// ./src/components/privacyPage/privacyPage.jsx